import { SHIFT } from "../actions/types";

const initialState = {
  getShiftsByProjectId: {
    shifts: {},
    successMessage: null,
    errorMessage: null,
    isFetching: false,
  },

  getShift: {
    shift: {},
    errorMessage: null,
    isFetching: false,
  },

  deleteShift: {
    successMessage: null,
    errorMessage: null,
    isFetching: false,
  },

  getActiveShifts: {
    shifts: [],
    isFetching: false,
  },

  getActiveShift: {
    shift: null,
    errorMessage: null,
    isFetching: false,
  },

  assignEmployees: {
    successMessage: null,
    errorMessage: null,
    isFetching: false,
  },

  getEmployeesOfShiftByCompany: {
    employees: [],
    errorMessage: null,
    isFetching: false,
  },

  duplicateShift: {
    successMessage: null,
    errorMessage: null,
    isFetching: false,
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    // #region SHIFT.GET_SHIFTS

    case SHIFT.SHIFT_GET_SHIFTS_REQUEST:
      return {
        ...state,
        getShiftsByProjectId: {
          shifts: {},
          successMessage: null,
          errorMessage: null,
          isFetching: true,
        },
      };

    case SHIFT.SHIFT_GET_SHIFTS_SUCCESS:
      return {
        ...state,
        getShiftsByProjectId: {
          shifts: action.payload,
          successMessage: "Diensten succesvol opgehaald.",
          errorMessage: null,
          isFetching: false,
        },
      };

    case SHIFT.SHIFT_GET_SHIFTS_FAIL:
      return {
        ...state,
        getShiftsByProjectId: {
          shifts: {},
          successMessage: null,
          errorMessage: action.payload,
          isFetching: false,
        },
      };

    // #endregion

    // #region SHIFT.GET_SHIFT

    case SHIFT.SHIFT_GET_SHIFT_REQUEST:
      return {
        ...state,
        getShift: {
          shift: {},
          errorMessage: null,
          isFetching: true,
        },
      };

    case SHIFT.SHIFT_GET_SHIFT_SUCCESS:
      return {
        ...state,
        getShift: {
          shift: action.payload,
          errorMessage: null,
          isFetching: false,
        },
      };

    case SHIFT.SHIFT_GET_SHIFT_FAIL:
      return {
        ...state,
        getShift: {
          shift: {},
          errorMessage: action.payload,
          isFetching: false,
        },
      };

    // #endregion

    // #region SHIFT.DELETE

    case SHIFT.SHIFT_DELETE_REQUEST:
      return {
        ...state,
        deleteShift: {
          successMessage: null,
          errorMessage: null,
          isFetching: true,
        },
      };

    case SHIFT.SHIFT_DELETE_SUCCESS:
      return {
        ...state,
        deleteShift: {
          successMessage: "Dienst verwijderen is voltooid",
          errorMessage: null,
          isFetching: false,
        },
      };

    case SHIFT.SHIFT_DELETE_FAIL:
      return {
        ...state,
        deleteShift: {
          successMessage: null,
          errorMessage: action.payload,
          isFetching: false,
        },
      };

    // #endregion

    // #region SHIFT.GET_ACTIVE_SHIFTS

    case SHIFT.SHIFT_GET_ACTIVE_SHIFTS_REQUEST:
      return {
        ...state,
        getActiveShifts: {
          shifts: [],
          isFetching: true,
        },
      };

    case SHIFT.SHIFT_GET_ACTIVE_SHIFTS_SUCCESS:
      return {
        ...state,
        getActiveShifts: {
          shifts: action.payload,
          isFetching: false,
        },
      };

    case SHIFT.SHIFT_GET_ACTIVE_SHIFTS_FAIL:
      return {
        ...state,
        getActiveShifts: {
          shifts: [],
          isFetching: false,
        },
      };

    // #endregion

    // #region SHIFT.GET_ACTIVE_SHIFT

    case SHIFT.SHIFT_GET_ACTIVE_SHIFT_REQUEST:
      return {
        ...state,
        getActiveShift: {
          shift: [],
          errorMessage: null,
          isFetching: true,
        },
      };

    case SHIFT.SHIFT_GET_ACTIVE_SHIFT_SUCCESS:
      return {
        ...state,
        getActiveShift: {
          shift: action.payload,
          errorMessage: null,
          isFetching: false,
        },
      };

    case SHIFT.SHIFT_GET_ACTIVE_SHIFT_FAIL:
      return {
        ...state,
        getActiveShift: {
          shift: [],
          errorMessage: action.payload,
          isFetching: false,
        },
      };

    // #endregion

    // #region SHIFT.ASSIGN_EMPLOYEES

    case SHIFT.SHIFT_ASSIGN_EMPLOYEES_REQUEST:
      return {
        ...state,
        assignEmployees: {
          successMessage: null,
          errorMessage: null,
          isFetching: true,
        },
      };

    case SHIFT.SHIFT_ASSIGN_EMPLOYEES_SUCCESS:
      return {
        ...state,
        assignEmployees: {
          successMessage: "Medewerkers inplannen is voltooid.",
          errorMessage: null,
          isFetching: false,
        },
      };

    case SHIFT.SHIFT_ASSIGN_EMPLOYEES_FAIL:
      return {
        ...state,
        assignEmployees: {
          successMessage: null,
          errorMessage: action.payload,
          isFetching: false,
        },
      };

    // #endregion

    // #region SHIFT.GET_EMPLOYEES_OF_COMPANY

    case SHIFT.SHIFT_GET_EMPLOYEES_OF_COMPANY_REQUEST:
      return {
        ...state,
        getEmployeesOfShiftByCompany: {
          employees: [],
          errorMessage: null,
          isFetching: true,
        },
      };

    case SHIFT.SHIFT_GET_EMPLOYEES_OF_COMPANY_SUCCESS:
      return {
        ...state,
        getEmployeesOfShiftByCompany: {
          employees: action.payload,
          errorMessage: null,
          isFetching: false,
        },
      };

    case SHIFT.SHIFT_GET_EMPLOYEES_OF_COMPANY_FAIL:
      return {
        ...state,
        getEmployeesOfShiftByCompany: {
          employees: [],
          errorMessage: action.payload,
          isFetching: false,
        },
      };

    // #endregion

    // #region SHIFT.DUPLICATE

    case SHIFT.SHIFT_DUPLICATE_REQUEST:
      return {
        ...state,
        duplicateShift: {
          successMessage: null,
          errorMessage: null,
          isFetching: true,
        },
      };

    case SHIFT.SHIFT_DUPLICATE_SUCCESS:
      return {
        ...state,
        duplicateShift: {
          successMessage: "Dienst dupliceren is voltooid",
          errorMessage: null,
          isFetching: false,
        },
      };

    case SHIFT.SHIFT_DUPLICATE_FAIL:
      return {
        ...state,
        duplicateShift: {
          successMessage: null,
          errorMessage: action.payload,
          isFetching: false,
        },
      };

    // #endregion

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/shiftReducer.js